import React, { useContext } from "react";
import { graphql } from "~/graphql";
import { ResultOf } from "@graphql-typed-document-node/core";

const UserFragment = graphql(`
  fragment UserFragment on User {
    id
    email
    name
    profilePicture
    surveyFilled
    isStaff
    signupDate
    username
    hasAddedResources
  }
`);

type UserFragmentType = ResultOf<typeof UserFragment>;

interface IUserContext {
  user: IUser;
  tags: string[];
  theme: "light" | "dark" | "";
  setTheme: (theme: "light" | "dark") => void;
}

export interface IUser extends UserFragmentType {
  authenticated: boolean;
  source: string;
  profilePictureURL: string;
  displayName: string;
}
export const UserContext = React.createContext<IUserContext>({
  user: {
    authenticated: false,
    id: "",
    name: "",
    email: "",
    profilePicture: "",
    surveyFilled: false,
    isStaff: false,
    source: "mindstone",
    signupDate: 0,
    username: "",
    displayName: "",
    profilePictureURL: "",
    hasAddedResources: false,
  },
  theme: "light",
  tags: [],
  setTheme: (theme) => {},
});

export const useUser = () => useContext(UserContext).user;
export const useTags = () => useContext(UserContext).tags;
export const useDarkMode = () => useContext(UserContext).theme === "dark";
export const useThemeSetter = () => useContext(UserContext).setTheme;
